import { render, staticRenderFns } from "./Manage-Service-Unit.vue?vue&type=template&id=84796984&"
import script from "./Manage-Service-Unit.vue?vue&type=script&lang=js&"
export * from "./Manage-Service-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports